// https://serverless-stack.com/chapters/upload-a-file-to-s3.html
import { Storage } from "aws-amplify";
var pathParse = require('path-parse');

export function getFilenameAndExtension(pathfilename){
    return [pathParse(pathfilename).name, pathParse(pathfilename).ext];
}

export async function s3Upload(file) {
  let filenameParts = getFilenameAndExtension(file.name);
  //const filename = `${filenameParts[0]}-${Date.now()}${filenameParts[1]}`;
  const filename = `${filenameParts[0]}${filenameParts[1]}`;

//   const stored = await Storage.vault.put(filename, file, { // use for private folder on s3
  const stored = await Storage.put(filename, file, {
    level: 'protected',
    contentType: file.type,
  });

  return stored.key;
}

export async function s3ListFiles(folder, level) {
  // https://docs.amplify.aws/lib/storage/list/q/platform/js
/*   await Storage.list(folder, { level: 'protected' })
      .then(result => console.log(result))
      .catch(err => console.log(err)); */
  var filenames = [];
/*   const s3Objects = await Storage.list(folder, { level: 'protected' });
  console.log('files: ', s3Objects);
  console.log('1st file: ', s3Objects[0].key); */
/*   await Storage.list(folder, { level: 'protected' })
    .then(result => {
      result.forEach(item => filenames.push(item.key))
    })
   .catch(err => console.error(err)) */

  let files = await Storage.list(folder, { level: 'protected' })
  files = await Promise.all(files);
  try {
    files.forEach(item => filenames.push(item.key));
  } catch (e) {
    console.error(e);
  }
   
  //console.log('filenames: ', filenames);
  return filenames;
}

export async function s3SignedUrls(folder, level) {
  //listFiles = async () => {
  // https://github.com/dabit3/basic-amplify-storage-example
  const files = await Storage.list(folder, { level: 'protected' });
  let signedFiles = files.map(f => Storage.get(f.key));
  signedFiles = await Promise.all(signedFiles);
  console.log('signedFiles: ', signedFiles);
  //this.setState({ files: signedFiles })
  return {files: signedFiles};
}

export function processStorageList(result) {
  // https://docs.amplify.aws/lib/storage/list/q/platform/js#public-level-list
  let files = []
  let folders = new Set()
  result.forEach(res => {
    if (res.size) {
      files.push(res)
      // sometimes files declare a folder with a / within then
      let possibleFolder = res.key.split('/').slice(0,-1).join('/')
      if (possibleFolder) folders.add(possibleFolder)
    } else {
      folders.add(res.key)
    }
  })
  return {files, folders}
}